import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/figma': {
    width: 341,
    height: 512,
    paths: [
      {
        d: 'M341.3 256C341.3 303.1 303.1 341.3 256 341.3S170.7 303.1 170.7 256 208.9 170.7 256 170.7 341.3 208.9 341.3 256zM256 170.7C303.1 170.7 341.3 132.5 341.3 85.4S303.1 0 256 0H85.3C38.2 0 0 38.2 0 85.3S38.2 170.6 85.3 170.6C38.2 170.7 0 208.9 0 256S38.2 341.3 85.3 341.3C38.2 341.3 0 379.5 0 426.7S38.2 512 85.3 512 170.6 473.8 170.6 426.7V170.7H256z'
      }
    ]
  }
})
